import { Reveal, Eyebrow } from "./Reveal";

const COLUMNS = [
  {
    n: "01",
    title: "Understand",
    lines: ["Who owns the property?", "What matters to the owner?", "What is changing around it?"],
  },
  {
    n: "02",
    title: "Research",
    lines: ["Land.", "Title.", "Zoning.", "Access.", "Development potential."],
  },
  {
    n: "03",
    title: "Explore",
    lines: ["Sell.", "Hold.", "Combine.", "Develop.", "Partner."],
  },
];

export const Approach = () => {
  return (
    <section id="owners" data-testid="our-approach-section" className="relative bg-[#18352C] py-24 sm:py-32 lg:py-40 scroll-mt-20 overflow-hidden">
      <div className="absolute inset-0 parcel-bg-dark opacity-[0.08] pointer-events-none" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-3xl">
          <Eyebrow dark>Our Approach</Eyebrow>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl text-[#F4F1EA] leading-[1.1] text-balance">
            Before we make an offer, <span className="italic text-[#A77A50]">we ask better questions.</span>
          </h2>
          <p className="mt-6 text-lg text-[#B9C4BB] leading-relaxed">
            Conversations involving someone&rsquo;s home, family property, inherited property, or long-held land can
            be personal. Our approach is simple:
          </p>
        </Reveal>
        <div className="mt-16 sm:mt-20 grid md:grid-cols-3 gap-12 md:gap-8 lg:gap-14">
          {COLUMNS.map((c, i) => (
            <Reveal key={c.n} delay={0.1 * i}>
              <span className="font-display text-6xl sm:text-7xl text-[#A77A50]" aria-hidden="true">{c.n}</span>
              <h3 className="mt-4 font-display text-2xl sm:text-3xl text-[#F4F1EA]">{c.title}</h3>
              <ul className="mt-6 divide-y divide-[#D9D6CE]/15">
                {c.lines.map((line) => (
                  <li key={line} className="py-3 text-base text-[#C9CFC8]">
                    {line}
                  </li>
                ))}
              </ul>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.25}>
          <div className="mt-16 sm:mt-20 pt-10 border-t border-[#D9D6CE]/15 flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-4">
            <p className="font-display text-2xl sm:text-3xl italic text-[#F4F1EA]">
              Not every conversation needs to end with a sale.
            </p>
            <p className="text-sm text-[#718477] tracking-wide">
              There is never an obligation simply because someone contacts us.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
